import UsersService from "../../../../services/users.sevice";
import ContrAgentService from "../../../../services/contragent.service";
const initialFilter = {
	department: null,
	regName: null,
	regDate: {
		value: null,
		value2: null
	},
	contragent: null,
};

var Filter = {

	props: {
		section: {
			type: String,
			default: 'KIRIM'
		}
	},

	created() {
		this.loadWarehouse();
		this.loadContragents();
	},
	data() {
		return {
			filter: {
				department: null,
				toDepartment: null,
				regName: null,
				regDate: {
					value: '',
					value2: ''
				},
				contragent: null,
				regNumber: null,
			},
			attributes: [

			],
			sendDate: [],
			dropdowns: {
				department: [],
				counterparties: [],
				transferPermittedDepartments: [],
			},
			depsId:[],

			enableWatch: true
		}
	},

	methods: {
		async clearParams() {
			this.attributes = [];
			this.filter.department = null;
			this.filter.toDepartment=null
			this.filter.regName=null
			this.filter.regDate.value =''
			this.filter.regDate.value2=''
			this.filter.contragent=null
			this.filter.regNumber=null
			this.sendDate = []
			await this.$emit('filtered', []);
		},
		loadWarehouse() {
			if (this.$can('get', 'permitted departments')) {
				UsersService.getPermittedDepartments().then(response => {
					this.dropdowns.department = response.data.permittedDepartments
					this.dropdowns.transferPermittedDepartments = response.data.transferPermittedDepartments
				})
			}
		},
		loadContragents() {
			ContrAgentService.search({
				page: 1, limit: 700
			}).then(response => {
				this.dropdowns.counterparties = response.data.items;
			})
		},
		hasRegNumber(attr) {
			return attr.field === 'regNumber'
		},
		hasRegDate(attr) {
			return attr.field === 'regDate'
		},
		hasDepartment(attr) {
			return attr.field === 'toDepartment.id'
		},
		hasFromDepartment(attr) {
			return attr.field === 'fromDepartment.id'
		},
		hasAgent(attr) {
			return attr.field === 'contragent.id'
		},


		filterItems() {
			this.correctDate();
			this.$emit('filtered', this.sendDate);
		},
		correctDate() {
			this.removeItemFromAttributes('regDate');

			// Add filter Greater_than
			if(this.filter.regDate.value !== '' && this.filter.regDate.value2 === ''){
				let row = {
					field: 'regDate',
					value: this.filter.regDate.value,
					option: 'GREATER_THAN',
					type: 'date'
				};
				this.attributes.push(row);

			}

			// Add filter LESS_THAN
			if(this.filter.regDate.value2 !== '' && this.filter.regDate.value === ''){

				let row = {
					field: 'regDate',
					value: this.filter.regDate.value2,
					option: 'LESS_THAN',
					type: 'date'
				};
				this.attributes.push(row);
			}

			// Add filter RANGE
			if(this.filter.regDate.value !== '' && this.filter.regDate.value2 !== ''){
				let row = {
					field: 'regDate',
					value: this.filter.regDate.value,
					value2:this.filter.regDate.value2,
					option: 'RANGE',
					type: 'date'
				};
				this.attributes.push(row);
			}

			this.sendDate.attr = this.attributes;
			this.sendDate.filter = this.filter

		},
		clear() {
			// this.enableWatch = false;
			// setTimeout(() => {
			// 	this.enableWatch = true;
			// 	this.filter = Object.assign({}, initialFilter);
			// }, 100);
			this.filter = Object.assign({}, initialFilter);
			this.attributes = [];
			this.$emit('filtered', []);
		},
		removeItemFromAttributes(field){
			var removeIndex = this.attributes.map(function(item) { return item.field; }).indexOf(field);
			if(removeIndex !== -1){
				this.attributes.splice(removeIndex, 1);
			}

		}
	},

	watch: {
		'filter.regNumber': {
			handler(newValue) {
				if (this.enableWatch && newValue !== '') {
					let row = this.attributes.find(this.hasRegNumber);
					if (!row) {
						row = {
							field: 'regNumber',
							value: newValue,
							option: 'CONTAINS'
						};
						this.attributes.push(row);
					} else {
						row.value = newValue;
					}
				}else{
					this.removeItemFromAttributes('regNumber')
				}
			}
		},

		'filter.department': {
			handler(newValue) {
				let row =  this.attributes.find((this.isKirim) ? this.hasDepartment : this.hasFromDepartment);
				if (this.enableWatch  && newValue !== '' && newValue !== null) {
					if (!row) {
						row = {
							field: (this.isKirim) ? 'toDepartment.id' : 'fromDepartment.id',
							value: newValue.id,
							option: 'EQUALS',
							type: 'long'
						};
						this.attributes.push(row);
					} else {
						row.value = newValue;
					}
				}else{

						this.removeItemFromAttributes((this.isKirim) ? 'toDepartment.id' : 'fromDepartment.id')
				}

			}
		},
		'filter.toDepartment': {
			handler(newValue) {
				let row =  this.attributes.find(this.hasDepartment);
				if (this.enableWatch  && newValue !== '' && newValue !== null) {

					if (!row) {
						row = {
							field: 'toDepartment.id' ,
							value: newValue.id,
							option: 'EQUALS',
							type: 'long'
						};
						this.attributes.push(row);
					} else {
						row.value = newValue;
					}
				}else{
					this.removeItemFromAttributes('toDepartment.id')
				}
			}
		},

		'filter.contragent': {
			handler(newValue) {
				if (this.enableWatch  && newValue !== '' && newValue !== null) {
					let row = this.attributes.find(this.hasAgent);

					if (!row) {
						row = {
							field: 'contragent.id',
							value: newValue,
							option: 'EQUALS',
							type: 'long'
						};
						this.attributes.push(row);
					} else {
						row.value = newValue;
					}
				}else{
					this.removeItemFromAttributes('contragent.id')
				}
			}
		},
		'$route': {
			handler() {
				this.attributes = [];
			}
		}

	},

	computed: {
		isKirim() {
			return this.section === 'KIRIM'
		},
		isChiqim() {
			return this.section === 'CHIQIM'
		},
		isTransfer() {
			return this.section === 'KOCHIRISH'
		}


	}
};

export default Filter;
